


import { initializeApp } from "firebase/app";
import {getFirestore,collection,getDocs,doc,getDoc} from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyACJOjPi9uz7evjg5K8DM2qNv-iGpIE8io",
  authDomain: "anubis-80e35.firebaseapp.com",
  projectId: "anubis-80e35",
  storageBucket: "anubis-80e35.appspot.com",
  messagingSenderId: "500149767976",
  appId: "1:500149767976:web:0a7267f45d3b794ae14a1d",
  measurementId: "G-7XRZ8511VH"
};





// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app)

export async function getSingleMacroReport(db,institution)
{
  const collectionRef = collection(db,"macro_reports")
  const docRef = doc(collectionRef,institution)
  return getDoc(docRef).then((res)=>res.data())
}

export async function getFullReport(db,institution)
{
  const collectionRef = collection(db,"anubis_reports")
  const docRef = doc(collectionRef,institution);
  return getDoc(docRef).then((res)=>res.data())
}

export async function getMacroReportNames(db)
{
  const collectionRef = collection(db,"macro_reports")
  const docs = await getDocs(collectionRef)

  const names=  []
  docs.forEach((doc)=>
  {
    names.push(doc.data()?.institution)
  })

  return names
}

export async function getMacroReports(db)
{
    const collectionRef = collection(db,'macro_reports')
    const docs =  await getDocs(collectionRef)
    const macroDocuments = []
    docs.forEach((doc)=>
    {
      macroDocuments.push(doc.data())
    })
    return macroDocuments
}